import { axiosInstance as request } from '@api/rest.service'

const api = '/inline-editing/data'

/**
 * @description GET /inline-editing/data/products/product
 * @returns {AxiosPromise<any>}
 */
export const GET_INLINE_EDITING_FOR_PRODUCT = () => request.get(`${api}/products/product`)

/**
 * @description GET /inline-editing/data/licenses/license
 * @returns {AxiosPromise<any>}
 */
export const GET_INLINE_EDITING_FOR_LICENSE = () => request.get(`${api}/licenses/license`)

/**
 * @description GET /inline-editing/data/subscriptions/subscription-period
 * @returns {AxiosPromise<any>}
 */
export const GET_INLINE_EDITING_FOR_SUB_PERIOD = () => request.get(`${api}/subscriptions/subscription-period`)
